
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import LandingPage from './components/LandingPage';
import LoginPage from './components/LoginPage'
import Visualization from './components/Visualization';
import AuthenticatedComponents from './components/authorization/AuthenticatedComponents';
import AdminRoute from './components/authorization/AdminRoute';
import AdminDashboard from './components/admin/AdminDashboard';
import NewsDetail from './components/NewsDetail';
import LeadershipDetail from './components/LeadershipDetail';
import AllNews from './components/AllNews';

function App() {
  return (
    <>
      {/* <Store> */}
      <Router>
        <Switch>
          <Route exact path='/'>
            <LandingPage />
          </Route>
          <Route path='/login'>
            <LoginPage />
          </Route>
          <Route exact path='/projects'>
            <AllNews />
          </Route>
          <Route path='/projects/:id'>
            <NewsDetail />
          </Route>
          <Route path='/leadership/:id'>
            <LeadershipDetail />
          </Route>
          <Route path='/admin'>
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          </Route>
          <AuthenticatedComponents>
            <Route exact path='/home'>
              <HomePage />
            </Route>
            <Route path='/visualization'>
              <Visualization />
            </Route>
          </AuthenticatedComponents>
        </Switch>
      </Router>
      {/* </Store> */}
    </>
  );
}

export default App;